// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_button__gDaeN {
  position: fixed;
  bottom: 24px;
  right: 24px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
  padding: 2px;
  box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
  transition: transform 0.2s ease-in-out;
  z-index: 5;
}
.styles_button__gDaeN:hover {
  cursor: pointer;
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/ScrollToTop/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,+CAAA;EACA,sCAAA;EACA,UAAA;AACF;AAAE;EACE,eAAA;EACA,sBAAA;AAEJ","sourcesContent":[".button {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  border-radius: 100%;\n  background-color: #fff;\n  display: flex;\n  padding: 2px;\n  box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;\n  transition: transform 0.2s ease-in-out;\n  z-index: 5;\n  &:hover{\n    cursor: pointer;\n    transform: scale(1.05);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `styles_button__gDaeN`
};
export default ___CSS_LOADER_EXPORT___;
